<template>
  <div class="rich-text-editor">
    <div style="border: 1px solid #ccc;">
      <Toolbar
        style="border-bottom: 1px solid #ccc"
        :editor="editorRef"
        :defaultConfig="toolbarConfig"
      />
      <Editor
        style="height: 300px; overflow-y: hidden;"
        v-model="html"
        :defaultConfig="editorConfig"
        @onCreated="handleCreated"
      />
    </div>
  </div>
</template>

<script>
import { ref, onBeforeUnmount, watch } from 'vue';
import { Editor, Toolbar } from '@wangeditor/editor-for-vue';
import '@wangeditor/editor/dist/css/style.css';

export default {
  name: 'RichTextEditor',
  components: {
    Editor,
    Toolbar
  },
  props: {
    modelValue: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    // 编辑器实例，必须用 ref
    const editorRef = ref(null);
    // 内容 HTML
    const html = ref(props.modelValue);
    
    // 获取API基础地址
    const apiBaseUrl = process.env.VUE_APP_API_BASE_URL || 'http://127.0.0.1:8000/api';
    
    // 编辑器配置
    const editorConfig = {
      placeholder: '请输入内容...',
      // 图片上传配置
      MENU_CONF: {
        uploadImage: {
          server: `${apiBaseUrl}/manage/upload/image`,
          // 自定义上传参数
          formData: {
            type: 'content' // 传递type参数
          },
          // 自定义请求头
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token') || ''}`
          },
          // 自定义上传图片
          customUpload(file, insertFn) {
            const formData = new FormData();
            formData.append('file', file);
            formData.append('type', 'content');
            
            console.log('富文本图片上传开始:', file.name);
            console.log('上传URL:', `${apiBaseUrl}/manage/upload/image`);
            
            // 直接使用axios上传
            import('axios').then(axios => {
              axios.default({
                url: `${apiBaseUrl}/manage/upload/image`,
                method: 'post',
                data: formData,
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'Authorization': `Bearer ${localStorage.getItem('token') || ''}`
                },
                timeout: 15000
              }).then(response => {
                console.log('富文本图片上传响应:', response.data);
                
                // 处理上传成功的响应
                if (response.data.errno === 0) {
                  let imgUrl = response.data.data[0].url;
                  
                  // 确保返回的是完整的绝对路径
                  if (imgUrl && !imgUrl.startsWith('http://') && !imgUrl.startsWith('https://')) {
                    // 从API基础URL中提取域名
                    const domainMatch = apiBaseUrl.match(/^(https?:\/\/[^\/]+)/);
                    const baseDomain = domainMatch ? domainMatch[1] : window.location.origin;
                    imgUrl = `${baseDomain}${imgUrl}`;
                  }
                  
                  console.log('富文本图片上传成功，插入URL:', imgUrl);
                  insertFn(imgUrl); // 插入图片
                  
                  // 导入ElMessage并显示成功提示
                  import('element-plus').then(({ ElMessage }) => {
                    ElMessage.success('图片上传成功');
                  });
                } else {
                  console.error('图片上传失败:', response.data.message || '未知错误');
                  
                  // 导入ElMessage并显示错误提示
                  import('element-plus').then(({ ElMessage }) => {
                    ElMessage.error('图片上传失败: ' + (response.data.message || '未知错误'));
                  });
                }
              }).catch(error => {
                console.error('图片上传异常:', error);
                
                // 导入ElMessage并显示错误提示
                import('element-plus').then(({ ElMessage }) => {
                  ElMessage.error('图片上传失败: ' + error.message);
                });
              });
            });
          }
        }
      }
    };
    
    // 工具栏配置
    const toolbarConfig = {
      // 工具栏选项
      excludeKeys: ['uploadVideo', 'insertVideo'] // 排除视频上传功能
    };
    
    // 编辑器创建完成时的回调
    const handleCreated = (editor) => {
      editorRef.value = editor; // 记录 editor 实例
    };
    
    // 监听内容变化，同步到父组件
    watch(html, (newValue) => {
      emit('update:modelValue', newValue);
    });
    
    // 监听父组件传值变化，更新编辑器内容
    watch(() => props.modelValue, (newValue) => {
      if (editorRef.value && html.value !== newValue) {
        html.value = newValue;
      }
    });
    
    // 组件销毁时，销毁编辑器
    onBeforeUnmount(() => {
      if (editorRef.value) {
        editorRef.value.destroy();
      }
    });
    
    return {
      editorRef,
      html,
      editorConfig,
      toolbarConfig,
      handleCreated
    };
  }
}
</script>

<style scoped>
.rich-text-editor {
  width: 100%;
}
</style>